import script from "./NewsDataAnalytics.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsDataAnalytics.vue?vue&type=script&setup=true&lang=js"

import "./NewsDataAnalytics.vue?vue&type=style&index=0&id=414346e4&scoped=true&lang=css"

import exportComponent from "D:\\project\\安可控\\Dtsc.Official.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-414346e4"]])

export default __exports__